module.exports = __webpack_public_path__ + "static/media/deleteicon.e60f24cf.svg";